module.exports = __webpack_public_path__ + "static/media/back12.116aa099.jpg";